import { useState } from 'react';

import analytics from 'utils/client/analytics/analytics';
import { UbiArticlePage } from 'utils/ubi/pages/useUbiArticle';

interface UseSendFeedbackArgs {
  ubi: UbiArticlePage;
  articleIdentifier: string;
}

export type ReasonKey = 'no-looking-for' | 'no-resolved' | 'confusing' | 'other';

/**
 * Hook which submits the reason why an article wasn't helpful
 * @param {string} articleIdentifier article analytics identifier
 * @return {boolean} response.isSubmittedReason check if the reason was submitted
 * @return {Function} response.submitReason function to submit a reason
 */
const useSubmitReason = ({ articleIdentifier }: UseSendFeedbackArgs) => {
  const [isSubmittedReason, setIsSubmittedReason] = useState<boolean>(false);

  const submitReason = (reason: ReasonKey) => {
    analytics.trackEvent({
      category: 'article-feedback-reason',
      action: reason,
      label: `/article/${articleIdentifier}/`,
      nonInteraction: true,
    });

    /* TODO ubiLog for each reason
    switch (reason) {
      case "X":
        ubi.logReasonX();
    }*/

    setIsSubmittedReason(true);
  };

  return {
    isSubmittedReason,
    submitReason,
  };
};

export default useSubmitReason;
